import { GA4Event } from '@jusbrasil-web/shared-ga4'

import { EVENT } from '../constants'

export interface GA4ThreadStartEventProps {
  threadId: string
  componentClass?: string | null
  componentName?: string | null
  featureClass?: string | null
  selectedOption?: string | null
  threadClass?: string | null
}

export class GA4ThreadStartEvent extends GA4Event {
  ga4_thread_id: GA4ThreadStartEventProps['threadId']
  ga4_component_class: GA4ThreadStartEventProps['componentClass']
  ga4_component_name: GA4ThreadStartEventProps['componentName']
  ga4_feature_class: GA4ThreadStartEventProps['featureClass']
  ga4_selected_option: GA4ThreadStartEventProps['selectedOption']
  ga4_thread_class: GA4ThreadStartEventProps['threadClass']

  constructor({
    threadId,
    componentClass = null,
    componentName = null,
    featureClass = null,
    selectedOption = null,
    threadClass = null,
  }: GA4ThreadStartEventProps) {
    super({ event: EVENT.THREAD_START })

    this.ga4_thread_id = threadId
    this.ga4_component_class = componentClass
    this.ga4_component_name = componentName
    this.ga4_feature_class = featureClass
    this.ga4_selected_option = selectedOption
    this.ga4_thread_class = threadClass
  }
}
